import React from 'react';
import SignIn from "./SignIn/SignIn.tsx";
import Upgrade from "./Upgrade/Upgrade.tsx";
import Models from "./Models/Models.tsx";
import RefillBalance from "./RefillBalance/RefillBalance.tsx";
import {useAppStore} from "../../../GlobalStore/GlobalStore.ts";

interface MiddleComponentProps {}

const MiddleComponent: React.FC<MiddleComponentProps> = ({ }) => {
    const dynamicStateObj = useAppStore((state: any) => state.dynamicStateObj);
    const userObj = useAppStore((state: any) => state.userObj);
    const { subscriptionPlan, remainingBalance, monthlyFreeMessages, user } = userObj;

    const LoadingSkeleton = () => (
        <div className="animate-pulse flex justify-center items-center">
            <div className="h-6 w-24 bg-gray-400 rounded-lg opacity-50"></div>
        </div>
    );


    const getComponent = () => {
        if (dynamicStateObj.isInitializing) return <LoadingSkeleton />;
        else if (!user) return <SignIn signInMessage={"⟢ Sign in ⟣"} />;
        else if (remainingBalance <= -5) return <RefillBalance />;
        else if (subscriptionPlan === null && monthlyFreeMessages <= 0) return <Upgrade/>;
        else return <Models />
    }
    const component = getComponent();

    return (
        <>
            {component}
        </>
    );
};

export default MiddleComponent;

